import { render, staticRenderFns } from "./juntaDirectivaListList.vue?vue&type=template&id=3cab2ca1"
import script from "./juntaDirectivaListList.vue?vue&type=script&lang=js"
export * from "./juntaDirectivaListList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports